export default __webpack_public_path__ + "static/key-brain--yellow-bebfc0c00f97e89960cff8b6645620f3.webp";